import { useEffect, useState } from "react";
import { memberApi } from "../lib/api";
import { Baby, ArrowUpRight } from "@phosphor-icons/react";

const FORMULE = { essai: "Cours d'essai", un_cours: "1 cours / semaine", deux_cours: "2 cours / semaine" };
const PAY = { paye: ["Payé", "text-emerald-300"], echec: ["Paiement refusé", "text-red-300"], rembourse: ["Remboursé", "text-white/50"] };

// « Mon Petit Samouraï » — l'espace parent Petits Samouraïs dans le portail /membres (même courriel que le parent payeur).
export default function MemberSamouraisSection() {
  const [spaces, setSpaces] = useState(null);

  useEffect(() => {
    memberApi.get("/member/samourais").then((r) => setSpaces(r.data.spaces || [])).catch(() => setSpaces([]));
  }, []);

  if (!spaces || spaces.length === 0) return null;

  return (
    <section className="border border-white/10 bg-[#0F0F0F] p-6 mb-8 kz-fade-up" data-testid="member-samourais-section">
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div>
          <p className="kz-mono text-[10px] tracking-[0.26em] uppercase text-white/40">Petits Samouraïs · 3-6 ans</p>
          <h2 className="kz-display text-2xl mt-1">Mon Petit Samouraï</h2>
          <p className="text-white/50 text-sm mt-1 max-w-md">
            Horaire, présences, paiement, carnet du Petit Samouraï avec vidéos et certificats — tout l'espace parent, directement depuis ton espace membre.
          </p>
        </div>
        <Baby size={36} className="text-[#D90429]" weight="duotone" />
      </div>
      <div className="mt-5 grid gap-3 sm:grid-cols-2">
        {spaces.map((s) => {
          const pay = PAY[s.payment_status] || ["Rapprochement requis", "text-amber-300"];
          return (
            <a key={s.eid} href={s.parent_path} target="_blank" rel="noreferrer" data-testid={`member-samourais-${s.eid}`}
              className="group flex items-center gap-4 border border-white/10 hover:border-[#D90429] bg-[#0A0A0A] px-4 py-3 transition-colors">
              <div className="w-12 h-12 bg-[#D90429]/15 border border-[#D90429]/40 flex items-center justify-center shrink-0 text-xl">🥋</div>
              <div className="flex-1 min-w-0">
                <div className="font-semibold text-white truncate">{s.child_name}</div>
                <div className="text-xs text-white/50 flex items-center gap-1.5 flex-wrap">
                  <span>{FORMULE[s.formule] || s.formule}</span>
                  <span>·</span>
                  <span className={pay[1]}>{pay[0]}</span>
                  {s.certificates > 0 && <><span>·</span><span>🏅 {s.certificates} certificat{s.certificates > 1 ? "s" : ""}</span></>}
                </div>
                {s.session_title && <div className="text-[11px] text-white/35 truncate mt-0.5">{s.session_title}</div>}
              </div>
              <ArrowUpRight size={18} className="text-white/40 group-hover:text-[#D90429] transition-colors" />
            </a>
          );
        })}
      </div>
    </section>
  );
}
